/* eslint-disable angular/component-name */
angular.module('zc.zenclerkS')
  .component('widgetTopItems', {
    templateUrl: '/templates/zenclerk_s/directives/dashboard/top_items_widget.html',
    bindings: {
      project: '<',
      sortOrder: '@',
    },
    controllerAs: 'vm',
    controller: function($state, MongoZcsDailyDiffStats, currencies) {
      const vm = this;

      vm.currency = currencies[vm.project.currency];

      // variables
      vm.stats = {};

      // actions
      vm.isLoading = true;

      vm.min = Math.min;
      vm.conversionTagSettingPage = $state.href('zenclerkS.project.tags.conversion', { projectId: vm.project.project_id });

      this.$onInit = () => {
        MongoZcsDailyDiffStats.find(
          {
            apikey: vm.project.apikey,
            // On 1st, show last month
            month: moment().subtract(1, 'days').format('YYYY-MM')
          },
          { sort: { summarize_at: -1 }, limit: 1 }
        ).then(res => {
          vm.isLoading = false;
          if(res && res[0]) {
          // take a copy because... well, same request is cached :o
            vm.stats = _.merge({}, res[0]);

            vm.stats.items = _.filter(vm.stats.items, d => d.monthly.pv >= 5);

            if(vm.sortOrder === 'asc') {
              vm.stats.items = _.sortBy(vm.stats.items, item => item.monthly.conversion_ratio);
            } else {
              vm.stats.items = _.sortBy(vm.stats.items, item => -item.monthly.conversion_ratio);
            }
          }
        });
      };
    }
  });



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/directives/dashboard/top_items_widget.js